var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.43959 7.93959 0.5 16.5 0.5C25.0604 0.5 32 7.43959 32 16C32 24.5604 25.0604 31.5 16.5 31.5C7.93959 31.5 1 24.5604 1 16Z",
    stroke: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6437 10.25H22.3955C22.2205 10.25 22.0544 10.3304 21.9473 10.4679L14.5848 19.7946L11.0544 15.3214C11.001 15.2536 10.9329 15.1988 10.8553 15.1611C10.7777 15.1233 10.6925 15.1037 10.6062 15.1036H9.35799C9.23835 15.1036 9.17228 15.2411 9.24549 15.3339L14.1366 21.5304C14.3651 21.8196 14.8044 21.8196 15.0348 21.5304L23.7562 10.4786C23.8294 10.3875 23.7633 10.25 23.6437 10.25Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsItemIcon);
export default __webpack_public_path__ + "static/media/steps-item-icon.493091c4446c9960756f421956a55e10.svg";
export { ForwardRef as ReactComponent };